var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c(
        "div",
        {
          staticClass: "siderbar-wrapper",
          style: { width: this.isCollapsed ? "80px" : "220px" },
        },
        [
          _c("div", { staticClass: "logo-wrapper" }, [
            !_vm.isCollapsed
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "24px",
                      "white-space": "nowrap",
                      "text-align": "left",
                      "padding-left": "20px",
                      "box-sizing": "border-box",
                    },
                  },
                  [_vm._v(" 小程序平台系统 ")]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                height: "calc(100vh - 360px)",
                "overflow-y": "auto",
              },
            },
            [
              _c(
                "el-menu",
                {
                  staticClass: "menu-wrapper",
                  style: { left: this.isCollapsed ? "-10px" : "0px" },
                  attrs: {
                    "background-color": "#000a4d",
                    "text-color": "#fff",
                    "active-text-color": "#fff",
                    router: "",
                    "unique-opened": "",
                    collapse: _vm.isCollapsed,
                    "default-active": _vm.$route.jumpUrl,
                  },
                  on: { open: _vm.test },
                },
                [
                  _vm._l(_vm.sider_menu_data, function (item, index) {
                    return [
                      !item.children
                        ? _c(
                            "el-menu-item",
                            {
                              key: index,
                              staticClass: "menu-item menu-itemFix",
                              attrs: { index: item.url },
                            },
                            [
                              _c("p", { staticClass: "elStyle" }, [
                                _c("img", {
                                  staticClass: "imgSize",
                                  attrs: {
                                    src: require("../../assets/menu1/" +
                                      item.iconUrl +
                                      ".png"),
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { slot: "title" },
                                    slot: "title",
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                              ]),
                            ]
                          )
                        : _c(
                            "el-submenu",
                            { attrs: { index: item.url } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("img", {
                                  staticClass: "imgSize",
                                  attrs: {
                                    src: require("../../assets/menu1/" +
                                      item.iconUrl +
                                      ".png"),
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "submenu",
                                    staticStyle: { position: "relative" },
                                    attrs: { slot: "title" },
                                    slot: "title",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(" " + _vm._s(item.name) + " "),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._l(
                                item.children,
                                function (sub_item, sub_index) {
                                  return _c(
                                    "el-menu-item",
                                    {
                                      key: sub_index,
                                      staticClass: "menu-item menu-itemFix",
                                      attrs: { index: sub_item.url },
                                      on: {
                                        click: function ($event) {
                                          return _vm.test(sub_item, item)
                                        },
                                      },
                                    },
                                    [
                                      _c("p", { staticClass: "elStyle" }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "34px",
                                            },
                                          },
                                          [_vm._v(_vm._s(sub_item.name))]
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          !_vm.isCollapsed
            ? _c("div", { staticClass: "lay-bottom" }, [
                _c("img", { attrs: { src: _vm.config.qrCodeUrl } }),
                _c("div", { staticClass: "l-bottom" }, [
                  _vm._v("扫码添加客服联系方式"),
                ]),
                _c("div", { staticClass: "l-bottom" }, [
                  _vm._v("客服名称：" + _vm._s(_vm.config.name)),
                ]),
                _c("div", { staticClass: "l-bottom" }, [
                  _vm._v("联系电话：" + _vm._s(_vm.config.contact)),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "topbar-wrapper",
          style: { left: this.isCollapsed ? "80px" : "220px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "menu-collapse-wrapper float-left",
              on: { click: _vm.toggleMenu },
            },
            [
              !_vm.isCollapsed
                ? _c("img", {
                    staticStyle: {
                      width: "24px",
                      height: "24px",
                      "margin-top": "12px",
                    },
                    attrs: {
                      src: require("../../assets/icon/icon_shouqi.png"),
                    },
                  })
                : _vm._e(),
              _vm.isCollapsed
                ? _c("img", {
                    staticStyle: {
                      width: "24px",
                      height: "24px",
                      "margin-top": "12px",
                    },
                    attrs: {
                      src: require("../../assets/icon/icon_zhankai.png"),
                    },
                  })
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "title float-left" }, [
            _vm.userInfo && _vm.userInfo.platformName
              ? _c("span", [_vm._v(_vm._s(_vm.userInfo.platformName))])
              : _vm._e(),
          ]),
          _c("ul", { staticClass: "menu-list float-right" }, [
            _c("li", { staticClass: "menu-item-title" }, [
              _c("div", { staticStyle: { display: "inline-block" } }, [
                _vm._v(" " + _vm._s(_vm.userName) + " "),
              ]),
            ]),
            _c(
              "li",
              { staticClass: "menu-item-title" },
              [
                _vm.userInfo.platformType == 0
                  ? _c(
                      "el-link",
                      {
                        staticStyle: {
                          color: "#2d46ee",
                          "margin-left": "10px",
                          "margin-right": "10px",
                        },
                        attrs: {
                          icon: "el-icon-question",
                          type: "primary",
                          href: "https://docs.qq.com/doc/DVXJOZEhFTWhkUEJr",
                          target: "_blank",
                        },
                      },
                      [_vm._v("帮助文档")]
                    )
                  : _c(
                      "el-link",
                      {
                        staticStyle: {
                          color: "#2d46ee",
                          "margin-left": "10px",
                          "margin-right": "10px",
                        },
                        attrs: {
                          icon: "el-icon-question",
                          type: "primary",
                          href: "https://docs.qq.com/doc/DVWdzWnZzWlV5dFdp",
                          target: "_blank",
                        },
                      },
                      [_vm._v("帮助文档")]
                    ),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      background: "#e9ecfe",
                      color: "#2d46ee",
                      "margin-left": "10px",
                    },
                    attrs: {
                      plain: "",
                      round: "",
                      type: "text",
                      icon: "el-icon-headset",
                    },
                    on: {
                      click: function ($event) {
                        _vm.isShow = true
                      },
                    },
                  },
                  [_vm._v("联系客服")]
                ),
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item-title", on: { click: _vm.exit } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      background: "#e9ecfe",
                      color: "#2d46ee",
                      "margin-left": "10px",
                    },
                    attrs: { plain: "", round: "", type: "text" },
                  },
                  [_vm._v("退出")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "nav",
          style: { left: this.isCollapsed ? "80px" : "220px" },
        },
        [_c("tarbar")],
        1
      ),
      _c(
        "div",
        {
          ref: "content-wrapper",
          staticClass: "content-wrapper",
          style: { left: this.isCollapsed ? "80px" : "220px" },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _c(
                    "keep-alive",
                    [
                      _vm.$route.meta.keepAlive
                        ? _c("router-view", { key: _vm.$route.name })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  !_vm.$route.meta.keepAlive
                    ? _c("router-view", { key: _vm.$route.name })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "50%" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("span", { staticStyle: { "margin-right": "40px" } }, [
                _vm._v("异常订单及时消息"),
              ]),
              _vm.activeName == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.allRead },
                    },
                    [_vm._v("非异常订单信息全部已读")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orderLoading,
                  expression: "orderLoading",
                },
              ],
              attrs: { "element-loading-text": "商品SKU更新中" },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    overflow: "scroll",
                    height: "400px",
                    border: "1px solid #ebeef5",
                  },
                },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "未读消息", name: "2" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.upRead },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "message", label: "消息" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.type == 2 &&
                                        scope.row.messageObj !== null
                                          ? _c(
                                              "div",
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " 订单号：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .orderNo
                                                          ? scope.row.messageObj
                                                              .orderNo
                                                          : "-"
                                                      ) +
                                                      "，渠道：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .platform
                                                          ? scope.row.messageObj
                                                              .platform
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _vm._l(
                                                  scope.row.messageObj
                                                    .goodsList,
                                                  function (item, index) {
                                                    return _c(
                                                      "p",
                                                      { key: index },
                                                      [
                                                        _vm._v(" 商品："),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#4b7902",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "   " +
                                                                _vm._s(
                                                                  item.updated ==
                                                                    false
                                                                    ? "待更新"
                                                                    : "已更新"
                                                                ) +
                                                                "："
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          _vm._s(
                                                            item.name
                                                              ? item.name
                                                              : "-"
                                                          ) +
                                                            ",sku:" +
                                                            _vm._s(
                                                              item.skuno
                                                                ? item.skuno
                                                                : "-"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _c("p", [
                                                  _vm._v(
                                                    " 商品数量：" +
                                                      _vm._s(
                                                        scope.row.totalQuantity
                                                          ? scope.row
                                                              .totalQuantity
                                                          : "-"
                                                      ) +
                                                      "，商品总价：" +
                                                      _vm._s(
                                                        scope.row.totalPrice
                                                          ? scope.row.totalPrice
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("p", [
                                                  _vm._v(
                                                    " 收货电话：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .phone
                                                          ? scope.row.messageObj
                                                              .phone
                                                          : "-"
                                                      ) +
                                                      "收货地址：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .address
                                                          ? scope.row.messageObj
                                                              .address
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("p", [
                                                  _vm._v(" 在线支付留言："),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .remarks
                                                          ? scope.row.messageObj
                                                              .remarks
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                scope.row.messageObj.notice
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .messageObj
                                                                .notice
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(scope.row.message)),
                                            ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "时间" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$moment(scope.row.createdTime)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "130" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.messageObj == null
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.read(
                                                      scope.row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("已读")]
                                            )
                                          : _vm._e(),
                                        scope.row.type == 2 &&
                                        scope.row.messageObj !== null
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.syncOrder(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("同步订单")]
                                            )
                                          : _vm._e(),
                                        scope.row.type == 2 &&
                                        scope.row.messageObj !== null
                                          ? _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-size": "12px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " 已更新" +
                                                    _vm._s(
                                                      scope.row.updatedNum
                                                    ) +
                                                    "条，还剩" +
                                                    _vm._s(
                                                      scope.row.notUpdated
                                                    ) +
                                                    "条 "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "已读消息", name: "1" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.readT },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "message", label: "消息" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.type === 2 &&
                                        scope.row.messageObj !== null
                                          ? _c(
                                              "div",
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " 订单号：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .orderNo
                                                          ? scope.row.messageObj
                                                              .orderNo
                                                          : "-"
                                                      ) +
                                                      "，渠道：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .platform
                                                          ? scope.row.messageObj
                                                              .platform
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _vm._l(
                                                  scope.row.messageObj
                                                    .goodsList,
                                                  function (item, index) {
                                                    return _c(
                                                      "p",
                                                      { key: index },
                                                      [
                                                        _vm._v(" 商品："),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#4b7902",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "   " +
                                                                _vm._s(
                                                                  item.updated ==
                                                                    false
                                                                    ? "待更新"
                                                                    : "已更新"
                                                                ) +
                                                                "："
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          _vm._s(
                                                            item.name
                                                              ? item.name
                                                              : "-"
                                                          ) +
                                                            ",sku:" +
                                                            _vm._s(
                                                              item.skuno
                                                                ? item.skuno
                                                                : "-"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _c("p", [
                                                  _vm._v(
                                                    " 商品数量：" +
                                                      _vm._s(
                                                        scope.row.totalQuantity
                                                          ? scope.row
                                                              .totalQuantity
                                                          : "-"
                                                      ) +
                                                      "，商品总价：" +
                                                      _vm._s(
                                                        scope.row.totalPrice
                                                          ? scope.row.totalPrice
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("p", [
                                                  _vm._v(
                                                    " 收货电话：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .phone
                                                          ? scope.row.messageObj
                                                              .phone
                                                          : "-"
                                                      ) +
                                                      "收货地址：" +
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .address
                                                          ? scope.row.messageObj
                                                              .address
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("p", [
                                                  _vm._v(" 在线支付留言："),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.messageObj
                                                          .remarks
                                                          ? scope.row.messageObj
                                                              .remarks
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                scope.row.messageObj.notice
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .messageObj
                                                                .notice
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(scope.row.message)),
                                            ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "时间" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$moment(scope.row.createdTime)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "100" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.type == 2 &&
                                        scope.row.messageObj !== null
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                  disabled:
                                                    scope.row.updateState ==
                                                    false
                                                      ? false
                                                      : true,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.syncOrder(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("同步订单")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.updateState == true
                                                  ? "更新完成"
                                                  : ""
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "kefu",
          staticStyle: { padding: "18px 32px" },
          attrs: { visible: _vm.isShow, width: "338px", title: "联系客服" },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "font-size": "16px", color: "#303033" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "18px" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "80px", "text-align": "right" } },
                    [_vm._v("客服名称：")]
                  ),
                  _c("div", [_vm._v(_vm._s(_vm.config.name))]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "18px" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "80px", "text-align": "right" } },
                    [_vm._v("联系电话：")]
                  ),
                  _c("div", [_vm._v(_vm._s(_vm.config.contact))]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "8px" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "80px", "text-align": "right" } },
                    [_vm._v("二维码：")]
                  ),
                  _c("img", {
                    staticStyle: { width: "108px", height: "108px" },
                    attrs: { src: _vm.config.qrCodeUrl },
                  }),
                ]
              ),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", {
                  staticStyle: { width: "80px", "text-align": "right" },
                }),
                _c(
                  "span",
                  { staticStyle: { "font-size": "14px", color: "#2d46ee" } },
                  [_vm._v("微信扫码添加客服联系方式")]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }